// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as ClientOptions, TDataShape } from '@hey-api/client-fetch';
import { client as _heyApiClient } from '../client';
import type {
  AvatarAdminAddAvatarKnowledgeDocumentsData,
  AvatarAdminAddAvatarKnowledgeDocumentsError,
  AvatarAdminAddAvatarKnowledgeDocumentsResponse,
  AvatarAdminCreateAvatarKnowledgeData,
  AvatarAdminCreateAvatarKnowledgeError,
  AvatarAdminCreateAvatarKnowledgeResponse,
  AvatarAdminCreateAvatarRoleData,
  AvatarAdminCreateAvatarRoleError,
  AvatarAdminCreateAvatarRoleResponse,
  AvatarAdminCreateVoiceLibraryData,
  AvatarAdminCreateVoiceLibraryError,
  AvatarAdminCreateVoiceLibraryResponse,
  AvatarAdminDeleteAvatarKnowledgeDocumentData,
  AvatarAdminDeleteAvatarKnowledgeDocumentError,
  AvatarAdminDeleteAvatarKnowledgeDocumentResponse,
  AvatarAdminDeleteAvatarKnowledgeIndexData,
  AvatarAdminDeleteAvatarKnowledgeIndexError,
  AvatarAdminDeleteAvatarKnowledgeIndexResponse,
  AvatarAdminDeleteAvatarKnowledgeRetiredIndexData,
  AvatarAdminDeleteAvatarKnowledgeRetiredIndexError,
  AvatarAdminDeleteAvatarKnowledgeRetiredIndexResponse,
  AvatarAdminDeleteAvatarRoleData,
  AvatarAdminDeleteAvatarRoleError,
  AvatarAdminDeleteVoiceLibraryData,
  AvatarAdminDeleteVoiceLibraryError,
  AvatarAdminGetAvatarKnowledgeData,
  AvatarAdminGetAvatarKnowledgeError,
  AvatarAdminGetAvatarKnowledgeOperationData,
  AvatarAdminGetAvatarKnowledgeOperationError,
  AvatarAdminGetAvatarKnowledgeOperationResponse,
  AvatarAdminGetAvatarKnowledgeResponse,
  AvatarAdminGetAvatarRoleData,
  AvatarAdminGetAvatarRoleError,
  AvatarAdminGetAvatarRoleResponse,
  AvatarAdminGetVoiceLibraryData,
  AvatarAdminGetVoiceLibraryError,
  AvatarAdminGetVoiceLibraryResponse,
  AvatarAdminListAvatarKnowledgeDocumentsData,
  AvatarAdminListAvatarKnowledgeDocumentsError,
  AvatarAdminListAvatarKnowledgeDocumentsResponse,
  AvatarAdminListAvatarKnowledgeOperationsData,
  AvatarAdminListAvatarKnowledgeOperationsError,
  AvatarAdminListAvatarKnowledgeOperationsResponse,
  AvatarAdminListAvatarKnowledgeRetiredIndexesData,
  AvatarAdminListAvatarKnowledgeRetiredIndexesError,
  AvatarAdminListAvatarKnowledgeRetiredIndexesResponse,
  AvatarAdminListAvatarRolesData,
  AvatarAdminListAvatarRolesError,
  AvatarAdminListAvatarRolesResponse,
  AvatarAdminListVoiceLibrariesData,
  AvatarAdminListVoiceLibrariesError,
  AvatarAdminListVoiceLibrariesResponse,
  AvatarAdminPreviewAvatarKnowledgeData,
  AvatarAdminPreviewAvatarKnowledgeError,
  AvatarAdminPreviewAvatarKnowledgeResponse,
  AvatarAdminRebuildAvatarKnowledgeData,
  AvatarAdminRebuildAvatarKnowledgeError,
  AvatarAdminRebuildAvatarKnowledgeResponse,
  AvatarAdminRefreshLiveTextPromptData,
  AvatarAdminRefreshLiveTextPromptError,
  AvatarAdminRefreshLiveTextPromptResponse,
  AvatarAdminSetAvatarKnowledgeEnabledData,
  AvatarAdminSetAvatarKnowledgeEnabledError,
  AvatarAdminSetAvatarKnowledgeEnabledResponse,
  AvatarAdminSetAvatarRoleEnabledData,
  AvatarAdminSetAvatarRoleEnabledError,
  AvatarAdminSetAvatarRoleEnabledResponse,
  AvatarAdminUpdateAvatarRoleData,
  AvatarAdminUpdateAvatarRoleError,
  AvatarAdminUpdateAvatarRoleResponse,
  AvatarAdminUpdateVoiceLibraryData,
  AvatarAdminUpdateVoiceLibraryError,
  AvatarAdminUpdateVoiceLibraryResponse,
  KeeperCreatePersonalVoiceData,
  KeeperCreatePersonalVoiceError,
  KeeperCreatePersonalVoiceResponse,
  KeeperCreateUserAvatarKnowledgeDocumentData,
  KeeperCreateUserAvatarKnowledgeDocumentError,
  KeeperCreateUserAvatarKnowledgeDocumentResponse,
  KeeperCreateVoiceCloneData,
  KeeperCreateVoiceCloneError,
  KeeperCreateVoiceCloneResponse,
  KeeperDeletePersonalVoiceData,
  KeeperDeletePersonalVoiceError,
  KeeperDeleteUserAvatarData,
  KeeperDeleteUserAvatarError,
  KeeperDeleteUserAvatarKnowledgeDocumentData,
  KeeperDeleteUserAvatarKnowledgeDocumentError,
  KeeperDeleteUserAvatarKnowledgeDocumentResponse,
  KeeperGetOrCreateUserAvatarData,
  KeeperGetOrCreateUserAvatarError,
  KeeperGetOrCreateUserAvatarResponse,
  KeeperGetUserAvatarKnowledgeData,
  KeeperGetUserAvatarKnowledgeError,
  KeeperGetUserAvatarKnowledgeOperationData,
  KeeperGetUserAvatarKnowledgeOperationError,
  KeeperGetUserAvatarKnowledgeOperationResponse,
  KeeperGetUserAvatarKnowledgeResponse,
  KeeperListAvatarsData,
  KeeperListAvatarsError,
  KeeperListAvatarsResponse,
  KeeperListVoiceLibrariesData,
  KeeperListVoiceLibrariesError,
  KeeperListVoiceLibrariesResponse,
  KeeperReviewVoiceData,
  KeeperReviewVoiceError,
  KeeperReviewVoiceResponse,
  KeeperUpdatePersonalVoiceData,
  KeeperUpdatePersonalVoiceError,
  KeeperUpdatePersonalVoiceResponse,
  KeeperUpdateUserAvatarData,
  KeeperUpdateUserAvatarError,
  KeeperUpdateUserAvatarKnowledgeDocumentData,
  KeeperUpdateUserAvatarKnowledgeDocumentError,
  KeeperUpdateUserAvatarKnowledgeDocumentResponse,
  KeeperUpdateUserAvatarResponse,
  LivesClaimData,
  LivesClaimError,
  LivesClaimResponse,
  LivesClearMemoryData,
  LivesClearMemoryError,
  LivesConfirmSeniorNoticeData,
  LivesConfirmSeniorNoticeError,
  LivesConfirmSeniorNoticeResponse,
  LivesDeleteLivePlaybacksData,
  LivesDeleteLivePlaybacksError,
  LivesGetAvatarData,
  LivesGetAvatarError,
  LivesGetAvatarResponse,
  LivesGetComplianceStatusData,
  LivesGetComplianceStatusError,
  LivesGetComplianceStatusResponse,
  LivesGetEmergencyContactData,
  LivesGetEmergencyContactError,
  LivesGetEmergencyContactResponse,
  LivesGetLiveData,
  LivesGetLiveError,
  LivesGetLivePlaybackData,
  LivesGetLivePlaybackError,
  LivesGetLivePlaybackResponse,
  LivesGetLivePlaybackShareDetailData,
  LivesGetLivePlaybackShareDetailError,
  LivesGetLivePlaybackShareDetailResponse,
  LivesGetLivePlaybackShareTokenData,
  LivesGetLivePlaybackShareTokenError,
  LivesGetLivePlaybackShareTokenResponse,
  LivesGetLiveResponse,
  LivesGetMyData,
  LivesGetMyError,
  LivesGetMyResponse,
  LivesListLivePlaybacksData,
  LivesListLivePlaybacksError,
  LivesListLivePlaybacksResponse,
  LivesPresetVideoActionData,
  LivesPresetVideoActionError,
  LivesPresetVideoActionResponse,
  LivesQueueData,
  LivesQueueError,
  LivesQueueResponse,
  LivesSendMessageData,
  LivesSendMessageError,
  LivesSendMessageResponse,
  LivesSubmitEmergencyContactData,
  LivesSubmitEmergencyContactError,
  LivesSubmitEmergencyContactResponse,
  LivesVerifyIdentityData,
  LivesVerifyIdentityError,
  LivesVerifyIdentityResponse,
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

export const avatarAdminListAvatarRoles = <ThrowOnError extends boolean = false>(
  options?: Options<AvatarAdminListAvatarRolesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    AvatarAdminListAvatarRolesResponse,
    AvatarAdminListAvatarRolesError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/admin/v1/avatar-roles',
    ...options,
  });
};

export const avatarAdminCreateAvatarRole = <ThrowOnError extends boolean = false>(
  options: Options<AvatarAdminCreateAvatarRoleData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AvatarAdminCreateAvatarRoleResponse,
    AvatarAdminCreateAvatarRoleError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/admin/v1/avatar-roles',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const avatarAdminRefreshLiveTextPrompt = <ThrowOnError extends boolean = false>(
  options: Options<AvatarAdminRefreshLiveTextPromptData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AvatarAdminRefreshLiveTextPromptResponse,
    AvatarAdminRefreshLiveTextPromptError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/admin/v1/avatar-roles/refresh-live-text-prompt',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const avatarAdminDeleteAvatarKnowledgeIndex = <ThrowOnError extends boolean = false>(
  options: Options<AvatarAdminDeleteAvatarKnowledgeIndexData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    AvatarAdminDeleteAvatarKnowledgeIndexResponse,
    AvatarAdminDeleteAvatarKnowledgeIndexError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/admin/v1/avatar-roles/{avatar_role_id}/knowledge',
    ...options,
  });
};

/**
 * Avatar knowledge is an independent sub-resource. It is only available
 * for system avatars and all cloud mutations return a durable operation.
 */
export const avatarAdminGetAvatarKnowledge = <ThrowOnError extends boolean = false>(
  options: Options<AvatarAdminGetAvatarKnowledgeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    AvatarAdminGetAvatarKnowledgeResponse,
    AvatarAdminGetAvatarKnowledgeError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/admin/v1/avatar-roles/{avatar_role_id}/knowledge',
    ...options,
  });
};

export const avatarAdminCreateAvatarKnowledge = <ThrowOnError extends boolean = false>(
  options: Options<AvatarAdminCreateAvatarKnowledgeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AvatarAdminCreateAvatarKnowledgeResponse,
    AvatarAdminCreateAvatarKnowledgeError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/admin/v1/avatar-roles/{avatar_role_id}/knowledge',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const avatarAdminListAvatarKnowledgeDocuments = <ThrowOnError extends boolean = false>(
  options: Options<AvatarAdminListAvatarKnowledgeDocumentsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    AvatarAdminListAvatarKnowledgeDocumentsResponse,
    AvatarAdminListAvatarKnowledgeDocumentsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/admin/v1/avatar-roles/{avatar_role_id}/knowledge/documents',
    ...options,
  });
};

export const avatarAdminAddAvatarKnowledgeDocuments = <ThrowOnError extends boolean = false>(
  options: Options<AvatarAdminAddAvatarKnowledgeDocumentsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AvatarAdminAddAvatarKnowledgeDocumentsResponse,
    AvatarAdminAddAvatarKnowledgeDocumentsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/admin/v1/avatar-roles/{avatar_role_id}/knowledge/documents',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const avatarAdminDeleteAvatarKnowledgeDocument = <ThrowOnError extends boolean = false>(
  options: Options<AvatarAdminDeleteAvatarKnowledgeDocumentData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    AvatarAdminDeleteAvatarKnowledgeDocumentResponse,
    AvatarAdminDeleteAvatarKnowledgeDocumentError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/admin/v1/avatar-roles/{avatar_role_id}/knowledge/documents/{document_id}',
    ...options,
  });
};

export const avatarAdminSetAvatarKnowledgeEnabled = <ThrowOnError extends boolean = false>(
  options: Options<AvatarAdminSetAvatarKnowledgeEnabledData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    AvatarAdminSetAvatarKnowledgeEnabledResponse,
    AvatarAdminSetAvatarKnowledgeEnabledError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/admin/v1/avatar-roles/{avatar_role_id}/knowledge/enabled',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const avatarAdminListAvatarKnowledgeOperations = <ThrowOnError extends boolean = false>(
  options: Options<AvatarAdminListAvatarKnowledgeOperationsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    AvatarAdminListAvatarKnowledgeOperationsResponse,
    AvatarAdminListAvatarKnowledgeOperationsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/admin/v1/avatar-roles/{avatar_role_id}/knowledge/operations',
    ...options,
  });
};

export const avatarAdminGetAvatarKnowledgeOperation = <ThrowOnError extends boolean = false>(
  options: Options<AvatarAdminGetAvatarKnowledgeOperationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    AvatarAdminGetAvatarKnowledgeOperationResponse,
    AvatarAdminGetAvatarKnowledgeOperationError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/admin/v1/avatar-roles/{avatar_role_id}/knowledge/operations/{operation_id}',
    ...options,
  });
};

export const avatarAdminPreviewAvatarKnowledge = <ThrowOnError extends boolean = false>(
  options: Options<AvatarAdminPreviewAvatarKnowledgeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AvatarAdminPreviewAvatarKnowledgeResponse,
    AvatarAdminPreviewAvatarKnowledgeError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/admin/v1/avatar-roles/{avatar_role_id}/knowledge/preview',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const avatarAdminRebuildAvatarKnowledge = <ThrowOnError extends boolean = false>(
  options: Options<AvatarAdminRebuildAvatarKnowledgeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AvatarAdminRebuildAvatarKnowledgeResponse,
    AvatarAdminRebuildAvatarKnowledgeError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/admin/v1/avatar-roles/{avatar_role_id}/knowledge/rebuild',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const avatarAdminListAvatarKnowledgeRetiredIndexes = <ThrowOnError extends boolean = false>(
  options: Options<AvatarAdminListAvatarKnowledgeRetiredIndexesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    AvatarAdminListAvatarKnowledgeRetiredIndexesResponse,
    AvatarAdminListAvatarKnowledgeRetiredIndexesError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/admin/v1/avatar-roles/{avatar_role_id}/knowledge/retired-indexes',
    ...options,
  });
};

export const avatarAdminDeleteAvatarKnowledgeRetiredIndex = <ThrowOnError extends boolean = false>(
  options: Options<AvatarAdminDeleteAvatarKnowledgeRetiredIndexData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    AvatarAdminDeleteAvatarKnowledgeRetiredIndexResponse,
    AvatarAdminDeleteAvatarKnowledgeRetiredIndexError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/admin/v1/avatar-roles/{avatar_role_id}/knowledge/retired-indexes/{cleanup_id}',
    ...options,
  });
};

export const avatarAdminDeleteAvatarRole = <ThrowOnError extends boolean = false>(
  options: Options<AvatarAdminDeleteAvatarRoleData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, AvatarAdminDeleteAvatarRoleError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/admin/v1/avatar-roles/{id}',
    ...options,
  });
};

export const avatarAdminGetAvatarRole = <ThrowOnError extends boolean = false>(
  options: Options<AvatarAdminGetAvatarRoleData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    AvatarAdminGetAvatarRoleResponse,
    AvatarAdminGetAvatarRoleError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/admin/v1/avatar-roles/{id}',
    ...options,
  });
};

export const avatarAdminUpdateAvatarRole = <ThrowOnError extends boolean = false>(
  options: Options<AvatarAdminUpdateAvatarRoleData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    AvatarAdminUpdateAvatarRoleResponse,
    AvatarAdminUpdateAvatarRoleError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/admin/v1/avatar-roles/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * SetAvatarRoleEnabled 独立控制角色启用/停用。创建接口恒为停用，
 * 编辑接口不再改动 enabled，启停统一走此接口。
 */
export const avatarAdminSetAvatarRoleEnabled = <ThrowOnError extends boolean = false>(
  options: Options<AvatarAdminSetAvatarRoleEnabledData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    AvatarAdminSetAvatarRoleEnabledResponse,
    AvatarAdminSetAvatarRoleEnabledError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/admin/v1/avatar-roles/{id}/enabled',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const avatarAdminListVoiceLibraries = <ThrowOnError extends boolean = false>(
  options?: Options<AvatarAdminListVoiceLibrariesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    AvatarAdminListVoiceLibrariesResponse,
    AvatarAdminListVoiceLibrariesError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/admin/v1/voice-libraries',
    ...options,
  });
};

export const avatarAdminCreateVoiceLibrary = <ThrowOnError extends boolean = false>(
  options: Options<AvatarAdminCreateVoiceLibraryData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AvatarAdminCreateVoiceLibraryResponse,
    AvatarAdminCreateVoiceLibraryError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/admin/v1/voice-libraries',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const avatarAdminDeleteVoiceLibrary = <ThrowOnError extends boolean = false>(
  options: Options<AvatarAdminDeleteVoiceLibraryData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, AvatarAdminDeleteVoiceLibraryError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/admin/v1/voice-libraries/{id}',
    ...options,
  });
};

export const avatarAdminGetVoiceLibrary = <ThrowOnError extends boolean = false>(
  options: Options<AvatarAdminGetVoiceLibraryData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    AvatarAdminGetVoiceLibraryResponse,
    AvatarAdminGetVoiceLibraryError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/admin/v1/voice-libraries/{id}',
    ...options,
  });
};

export const avatarAdminUpdateVoiceLibrary = <ThrowOnError extends boolean = false>(
  options: Options<AvatarAdminUpdateVoiceLibraryData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    AvatarAdminUpdateVoiceLibraryResponse,
    AvatarAdminUpdateVoiceLibraryError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/admin/v1/voice-libraries/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * List available avatar roles with pagination.
 */
export const keeperListAvatars = <ThrowOnError extends boolean = false>(
  options?: Options<KeeperListAvatarsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<KeeperListAvatarsResponse, KeeperListAvatarsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/keeper/avatar/roles',
    ...options,
  });
};

/**
 * Get or create the current user's configurable avatar draft.
 */
export const keeperGetOrCreateUserAvatar = <ThrowOnError extends boolean = false>(
  options: Options<KeeperGetOrCreateUserAvatarData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    KeeperGetOrCreateUserAvatarResponse,
    KeeperGetOrCreateUserAvatarError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/keeper/avatar/user',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Update the current user's configurable avatar. Passing status=active confirms the avatar.
 */
export const keeperUpdateUserAvatar = <ThrowOnError extends boolean = false>(
  options: Options<KeeperUpdateUserAvatarData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    KeeperUpdateUserAvatarResponse,
    KeeperUpdateUserAvatarError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/keeper/avatar/user/{avatar_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Get the current user's knowledge configuration for a user avatar.
 */
export const keeperGetUserAvatarKnowledge = <ThrowOnError extends boolean = false>(
  options: Options<KeeperGetUserAvatarKnowledgeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    KeeperGetUserAvatarKnowledgeResponse,
    KeeperGetUserAvatarKnowledgeError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/keeper/avatar/{avatar_id}/knowledge',
    ...options,
  });
};

/**
 * Delete the only knowledge document owned by a user avatar.
 */
export const keeperDeleteUserAvatarKnowledgeDocument = <ThrowOnError extends boolean = false>(
  options: Options<KeeperDeleteUserAvatarKnowledgeDocumentData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    KeeperDeleteUserAvatarKnowledgeDocumentResponse,
    KeeperDeleteUserAvatarKnowledgeDocumentError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/keeper/avatar/{avatar_id}/knowledge/document',
    ...options,
  });
};

/**
 * Add the only knowledge document owned by a user avatar.
 */
export const keeperCreateUserAvatarKnowledgeDocument = <ThrowOnError extends boolean = false>(
  options: Options<KeeperCreateUserAvatarKnowledgeDocumentData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    KeeperCreateUserAvatarKnowledgeDocumentResponse,
    KeeperCreateUserAvatarKnowledgeDocumentError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/keeper/avatar/{avatar_id}/knowledge/document',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Replace the only knowledge document owned by a user avatar.
 */
export const keeperUpdateUserAvatarKnowledgeDocument = <ThrowOnError extends boolean = false>(
  options: Options<KeeperUpdateUserAvatarKnowledgeDocumentData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    KeeperUpdateUserAvatarKnowledgeDocumentResponse,
    KeeperUpdateUserAvatarKnowledgeDocumentError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/keeper/avatar/{avatar_id}/knowledge/document',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Get a user avatar knowledge operation.
 */
export const keeperGetUserAvatarKnowledgeOperation = <ThrowOnError extends boolean = false>(
  options: Options<KeeperGetUserAvatarKnowledgeOperationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    KeeperGetUserAvatarKnowledgeOperationResponse,
    KeeperGetUserAvatarKnowledgeOperationError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/keeper/avatar/{avatar_id}/knowledge/operations/{operation_id}',
    ...options,
  });
};

/**
 * Delete (archive) the current user's avatar by ID.
 */
export const keeperDeleteUserAvatar = <ThrowOnError extends boolean = false>(
  options: Options<KeeperDeleteUserAvatarData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, KeeperDeleteUserAvatarError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/keeper/avatar/{id}',
    ...options,
  });
};

/**
 * Clone a user voice from uploaded audio.
 */
export const keeperCreateVoiceClone = <ThrowOnError extends boolean = false>(
  options: Options<KeeperCreateVoiceCloneData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    KeeperCreateVoiceCloneResponse,
    KeeperCreateVoiceCloneError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/keeper/voice/clone',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Create a personal voice for the current user's voice library.
 * Unlike CreateVoiceClone, this does not bind to any avatar and returns an
 * immediately-usable voice. New clients use this; CreateVoiceClone is kept
 * for legacy client compatibility.
 */
export const keeperCreatePersonalVoice = <ThrowOnError extends boolean = false>(
  options: Options<KeeperCreatePersonalVoiceData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    KeeperCreatePersonalVoiceResponse,
    KeeperCreatePersonalVoiceError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/keeper/voice/personal',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Delete a personal voice owned by the current user.
 */
export const keeperDeletePersonalVoice = <ThrowOnError extends boolean = false>(
  options: Options<KeeperDeletePersonalVoiceData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, KeeperDeletePersonalVoiceError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/keeper/voice/personal/{voice_library_id}',
    ...options,
  });
};

/**
 * Update a personal voice owned by the current user. Only display_name is editable.
 */
export const keeperUpdatePersonalVoice = <ThrowOnError extends boolean = false>(
  options: Options<KeeperUpdatePersonalVoiceData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    KeeperUpdatePersonalVoiceResponse,
    KeeperUpdatePersonalVoiceError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/keeper/voice/personal/{voice_library_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Review uploaded audio before cloning.
 */
export const keeperReviewVoice = <ThrowOnError extends boolean = false>(
  options: Options<KeeperReviewVoiceData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<KeeperReviewVoiceResponse, KeeperReviewVoiceError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/keeper/voice/review',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * List voice libraries. source=system (default) returns system voices;
 * source=user returns the current user's personal voices (requires auth).
 */
export const keeperListVoiceLibraries = <ThrowOnError extends boolean = false>(
  options?: Options<KeeperListVoiceLibrariesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    KeeperListVoiceLibrariesResponse,
    KeeperListVoiceLibrariesError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/keeper/voice_libraries',
    ...options,
  });
};

export const livesGetAvatar = <ThrowOnError extends boolean = false>(
  options: Options<LivesGetAvatarData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<LivesGetAvatarResponse, LivesGetAvatarError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/live/avatar/{avatar_id}',
    ...options,
  });
};

export const livesClaim = <ThrowOnError extends boolean = false>(options: Options<LivesClaimData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<LivesClaimResponse, LivesClaimError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/live/claim',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const livesConfirmSeniorNotice = <ThrowOnError extends boolean = false>(
  options: Options<LivesConfirmSeniorNoticeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    LivesConfirmSeniorNoticeResponse,
    LivesConfirmSeniorNoticeError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/live/compliance/confirm-senior-notice',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const livesGetEmergencyContact = <ThrowOnError extends boolean = false>(
  options?: Options<LivesGetEmergencyContactData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    LivesGetEmergencyContactResponse,
    LivesGetEmergencyContactError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/live/compliance/emergency-contact',
    ...options,
  });
};

export const livesSubmitEmergencyContact = <ThrowOnError extends boolean = false>(
  options: Options<LivesSubmitEmergencyContactData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    LivesSubmitEmergencyContactResponse,
    LivesSubmitEmergencyContactError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/live/compliance/emergency-contact',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const livesVerifyIdentity = <ThrowOnError extends boolean = false>(
  options: Options<LivesVerifyIdentityData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<LivesVerifyIdentityResponse, LivesVerifyIdentityError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/live/compliance/identity-verification',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const livesGetComplianceStatus = <ThrowOnError extends boolean = false>(
  options?: Options<LivesGetComplianceStatusData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    LivesGetComplianceStatusResponse,
    LivesGetComplianceStatusError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/live/compliance/status',
    ...options,
  });
};

export const livesClearMemory = <ThrowOnError extends boolean = false>(
  options: Options<LivesClearMemoryData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, LivesClearMemoryError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/live/memory/clear',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const livesSendMessage = <ThrowOnError extends boolean = false>(
  options: Options<LivesSendMessageData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<LivesSendMessageResponse, LivesSendMessageError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/live/message',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const livesGetMy = <ThrowOnError extends boolean = false>(options?: Options<LivesGetMyData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<LivesGetMyResponse, LivesGetMyError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/live/my',
    ...options,
  });
};

export const livesDeleteLivePlaybacks = <ThrowOnError extends boolean = false>(
  options: Options<LivesDeleteLivePlaybacksData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, LivesDeleteLivePlaybacksError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/live/playbacks/batch/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const livesListLivePlaybacks = <ThrowOnError extends boolean = false>(
  options?: Options<LivesListLivePlaybacksData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    LivesListLivePlaybacksResponse,
    LivesListLivePlaybacksError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/live/playbacks/my',
    ...options,
  });
};

export const livesGetLivePlayback = <ThrowOnError extends boolean = false>(
  options: Options<LivesGetLivePlaybackData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<LivesGetLivePlaybackResponse, LivesGetLivePlaybackError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/live/playbacks/{id}',
    ...options,
  });
};

export const livesGetLivePlaybackShareDetail = <ThrowOnError extends boolean = false>(
  options: Options<LivesGetLivePlaybackShareDetailData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    LivesGetLivePlaybackShareDetailResponse,
    LivesGetLivePlaybackShareDetailError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/live/playbacks/{id}/share',
    ...options,
  });
};

export const livesGetLivePlaybackShareToken = <ThrowOnError extends boolean = false>(
  options: Options<LivesGetLivePlaybackShareTokenData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    LivesGetLivePlaybackShareTokenResponse,
    LivesGetLivePlaybackShareTokenError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/live/playbacks/{id}/share',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const livesPresetVideoAction = <ThrowOnError extends boolean = false>(
  options?: Options<LivesPresetVideoActionData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    LivesPresetVideoActionResponse,
    LivesPresetVideoActionError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/live/preset/video-action',
    ...options,
  });
};

/**
 * Queue returns queue status SSE (Server-Sent Events)
 */
export const livesQueue = <ThrowOnError extends boolean = false>(options?: Options<LivesQueueData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<LivesQueueResponse, LivesQueueError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/live/queue',
    ...options,
  });
};

export const livesGetLive = <ThrowOnError extends boolean = false>(
  options: Options<LivesGetLiveData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<LivesGetLiveResponse, LivesGetLiveError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/live/v1/live/{live_id}',
    ...options,
  });
};
